import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { LoginUser } from "../../redux/action";
import { toast } from 'react-toastify'



const RhealLogin = () => {

    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const initialValues = {
        email: email,
        password: password,
    }

    const formik = useFormik({
        initialValues,
        onSubmit: async (values, { setStatus, setSubmitting }) => {
            if (email !== "" && password !== "") {
                setLoading(true)
                fetch(`${process.env.REACT_APP_API_URL_MAIN}login`, {
                    method: "POST",
                    headers: {},
                    body: JSON.stringify({ 'email': email, 'password': password }),
                })
                    .then((result) => {
                        result.json().then((response) => {
                            if (response.status === 1) {
                                storeData(response);
                            } else {
                                setStatus('The login detail is incorrect')
                                toast.error("action failed!!", {
                                    position: "top-center"
                                })
                                setSubmitting(false)
                                setLoading(false)
                            }
                            setLoading(false);
                        });
                    })
                    .catch(() => {
                        setStatus('The login detail is incorrect')
                        setSubmitting(false)
                        setLoading(false)
                    });

                const storeData = (res: any) => {
                    const adminLoginData = {
                        id: res?.data?.admin?.id,
                        email: res?.data?.admin?.email,
                        password: res?.data?.admin?.password,
                        hospital_name: res?.data?.admin?.hospital_name,
                        address: res?.data?.admin?.address,
                        currency: res?.data?.admin?.currency,
                        phone: res?.data?.admin?.phone,
                        status: res?.data?.admin?.status,
                        last_update: res?.data?.admin?.last_update,
                    };
                    dispatch(LoginUser(adminLoginData));
                    navigate("/");
                };
            }
        },
    })
    return (
        <form
            className='form w-100'
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'
            style={{ color: 'black' }}
        >
            <div className='text-center mb-10'>
                <img src='./image/4.svg' alt="BSV_LOGO" />
            </div>
            <div className='fv-row mb-10'>
                <label className='form-label fs-6 fw-bolder text-dark' style={{ color: 'black', fontFamily: 'Poppins' }} >Username</label>
                <input
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder='Email'
                    className={'form-control form-control-lg form-control-solid'}
                    type='email'
                    name='email'
                    autoComplete='on'
                />
                {formik.touched.email && formik.errors.email && (
                    <div className='fv-plugins-message-container'>
                        <span role='alert'>{formik.errors.email}</span>
                    </div>
                )}
            </div>
            <div className='fv-row mb-10'>
                <div className='d-flex justify-content-between mt-n5'>
                    <div className='d-flex flex-stack mb-2'>
                        <label style={{ color: 'black', fontFamily: 'Poppins' }} className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
                        <Link
                            to='forgot-password'
                            className='fs-6 fw-bolder'
                            style={{ marginLeft: '10px', color: "#878CB9" }}
                        >
                            Forgot Password ?
                        </Link>
                    </div>
                </div>
                <input
                    onChange={(e) => setPassword(e.target.value)}
                    type='password'
                    autoComplete='on'
                    className={'form-control form-control-lg form-control-solid'}
                    placeholder="Password"
                />
                {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.password}</span>
                        </div>
                    </div>
                )}
            </div>
            <div className='text-center'>
                <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className='btn btn-lg w-100 mb-5'
                    style={{ backgroundColor: ' #15B8CB', color: "white" }}
                    disabled={formik.isSubmitting || !formik.isValid}
                >
                    {!loading && <span className='indicator-label'>Login</span>}
                    {loading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
            </div>
        </form>
    )
}

export default RhealLogin